// import { AddressPost } from '../models/address-post';
// import { FriendStudentPost } from '../models/friend-student-post'

export class ContactRequest {

  constructor() {
    this.name = '';
    this.phone = '';
    this.email = '';
    this.message = '';
    this.subject = 'select';
  }

  name: string;
  phone: string;
  email: string;
  message: string;
  subject: string;
}



// WEBPACK FOOTER //
// ./src/app/models/contact-request.ts